import { EstadoPreventaEnum, EstadoProspectoEnum, handleAxiosError, ROUTER_PATHS, validateCelularRestriccion } from "@/shared";
import { useFetchCoberturasSector, useFetchParametros } from "@/shared/actions/erp";
import { useFetchPutSolicitudCanje } from "@/shared/actions/erp/marketing";
import { useFetchPutSolicitudEvento } from "@/shared/actions/erp/marketing/solicitudEvento.action";
import {
  usePostPlanCorporativo,
  usePutPlanCorporativo,
} from "@/shared/actions/erp/planes";
import {
  fetchPostPreventaCorporativo,
  fetchPutPreventaCorporativo,
} from "@/shared/actions/erp/preventa_corporativo/preventa_corporativo.action";
import {
  getProspectoCorporativoEspecial,
  usePostProspectoCorporativo,
  usePutProspectoCorporativo,
  validateSellByOtherUser,
} from "@/shared/actions/erp/prospecto_corporativo.actions";
import {
  AlertSeverityEnum,
  CondicionVentaCorporativa,
  IDataProspectoCorporativoParams,
  IProspectoCorporativo,
  ISolicitudCanje,
  ISolicitudEvento,
  TipoPlanCorporativo,
} from "@/shared/interfaces";
import { HTTPResStatusCodeEnum } from "@/shared/interfaces/erp/global/response-axios.interface";
import { IPreventaCorporativoForm2 } from "@/shared/interfaces/erp/preventa/preventa_corporativo.interface";
import { useAuthStore } from "@/store/auth";
import { MaterialesKey, useMaterialesUtilizadosStore } from "@/store/erp";
import { useUiStore } from "@/store/ui";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";


type SavePreventaProps = {
  dataProspecto?: IProspectoCorporativo;
  dataPreventaCorporativa?: IPreventaCorporativoForm2;
  enableEdit?: boolean
  withPreviousProspecto?: boolean
}



type SaveFormData = IPreventaCorporativoForm2 & {
  tipo_identificacion?: string;
  prospecto_corporativo_options?: IProspectoCorporativo[];
  condicion_venta?: CondicionVentaCorporativa | string | null;
  requiere_inspeccion?: boolean;
  requiere_cotizacion?: boolean;
  solicitud_canje?: string;
  solicitud_evento?: string;
  solicitud_canje_data?: ISolicitudCanje | null;
  solicitud_evento_data?: ISolicitudEvento | null;
  identificacion_canje_evento?: string;
  pre_documentos?: any[]
  documentos_guardados?: boolean
  documentos?: any[]
};

export const useSavePreventaCorporativa = ({
  dataProspecto,
  dataPreventaCorporativa,
  enableEdit,
  withPreviousProspecto,
}: SavePreventaProps) => {
  // =========================================================================
  // CONSTANTS
  // =========================================================================
  const navigate = useNavigate();
  const setAlert = useUiStore(s => s.setAlert);
  const setIsGlobalLoading = useUiStore((s) => s.setIsGlobalLoading);
  const currentUsername = useAuthStore(s => s.user)?.username!
  const serviciosAdicionalesDigitales = useMaterialesUtilizadosStore().serviciosAdicionalesDigitales
  const setSelectedItems = useMaterialesUtilizadosStore().setSelectedItems
  const clearSelectedItems = useMaterialesUtilizadosStore().clearSelectedItems

  // =========================================================================
  // STATES
  // =========================================================================
  const [SectorByZone, setSectorByZone] = useState<string>();

  // =========================================================================
  // FORMULARIOS
  // =========================================================================
  const form = useForm<SaveFormData, any, SaveFormData>({
    // resolver: yupResolver(PreventaCorporativaSchema),
    defaultValues: {
      requiere_backup: false,
      coordenada_fusion: "0,0",
      coordenada_empresa: "0,0",
      coordenada_servicio: "0,0",
      aumentar_disponibilidad: false,
      plan_personalizado: true,
      area_responsable_inspeccion: null,
    },
  });
  const { handleSubmit, reset } = form;
  const [valorRestriccionCel, setValorRestriccionCel] = useState<any>({});

  const { data: dataParamRestriccionCel, isLoading: isLoadingParamRestriccionCel } = useFetchParametros({
    enabled: true,
    params: {
      slug: "RESTRICCION_CELULAR"
    }
  });

  // =========================================================================
  // USE EFFECTS
  // =========================================================================
  useEffect(() => {
    if (!isLoadingParamRestriccionCel) {
      setValorRestriccionCel(
        dataParamRestriccionCel?.data?.data?.[0]?.valor 
        ? JSON.parse(dataParamRestriccionCel?.data?.data?.[0]?.valor) 
        : {}
      );
    }
  }, [isLoadingParamRestriccionCel, dataParamRestriccionCel])
  useEffect(() => {
    clearSelectedItems(MaterialesKey.serviciosAdicionalesDigitales)
    const {
      pais_data,
      trazo_venta_data,
      observaciones,
      numero_referencia,
      codigo,
      ...rest
    } = dataProspecto || {};

    reset({
      ...rest,
      ...pais_data,
      ...trazo_venta_data,
      ...observaciones,
      prospecto_corporativo: dataProspecto?.codigo,
      //prospecto_data: rest,
      prospecto_corporativo_data: rest,

      capacidad: "",

      tiene_cdns: false,
      energia_regulada: false,
      espacio_equipos: false,
      instalacion_ductos: false,
      seguridad_perimetral: false,
      wifi_gestionado: false,
      cableado_interno: false,
      equipos_adicionales: [],

      plan_personalizado: dataProspecto?.condicion_venta ? true : false,

      ejecutivo_comercial: dataProspecto?.user_create!,
      ips: [],
      // identificacion: dataProspecto?.identificacion!,
    });
    if (dataPreventaCorporativa) {
      const { tipo_cliente, ...restDataPreventaCorporativa } =
        dataPreventaCorporativa;

      reset({
        ...form.getValues(),
        ...restDataPreventaCorporativa,
        capacidad:
          restDataPreventaCorporativa.data_plan_personalizado
            ?.capacidad_personalizado,
        observacion_preventa: restDataPreventaCorporativa.observaciones?.observacion_preventa,
        observacion_prefactibilidad: restDataPreventaCorporativa.observaciones?.observacion_prefactibilidad,
        observacion_vendedor: restDataPreventaCorporativa.observaciones?.observacion_vendedor || restDataPreventaCorporativa.observacion_vendedor,
        documentos: restDataPreventaCorporativa.documentos,
        documentos_guardados: (restDataPreventaCorporativa.documentos?.length || 0) > 0 ? true : false,
        plan_tvmax: restDataPreventaCorporativa.plan_tvmax,
        usuarios_plan_tvmax: restDataPreventaCorporativa.plan_tvmax?.usuarios_plan_tvmax,
        ejecutivo_comercial: restDataPreventaCorporativa?.prospecto_corporativo_data?.user_create, //agregamos ejecutivo comercial  
      });
      setSelectedItems(dataPreventaCorporativa?.servicios_adicionales || [], MaterialesKey.serviciosAdicionalesDigitales)

    }

    // handleUbicacion()
  }, []);

  const { data: sectorsByZonePaging, isLoading: isLoadingSectors } =
    useFetchCoberturasSector(
      {
        zona: SectorByZone,
        page_size: 1000,
        cobertura: true,
        estado: true,
      },
      !!SectorByZone
    );

  useEffect(() => {
    if (form.getValues().zona != undefined && form.getValues().zona != "")
      setSectorByZone(form.watch().zona!);
  }, [form.watch().zona]);

  // ===========================================================================
  // MUTATIONS
  // ===========================================================================
  const { mutateAsync: mutateAsyncPostPlanCorporativo } =
    usePostPlanCorporativo({});
  const { mutateAsync: mutateAsyncPutPlanCorporativo } = usePutPlanCorporativo(
    {}
  );
  const { mutateAsync: mutatePutProspectoCorporativo } =
    usePutProspectoCorporativo({});
  const { mutateAsync: mutatePostProspectoCorporativo } =
    usePostProspectoCorporativo({ enableSuccessAlert: false });
  const { mutateAsync: putSolicitudCanje } = useFetchPutSolicitudCanje({});
  const { mutateAsync: putSolicitudEvento } = useFetchPutSolicitudEvento({});

  const {
    isPending: loadingPostPreventaCorporativo,
    mutateAsync: mutateAsyncPostPreventaCorporativo,
  } = fetchPostPreventaCorporativo({
    enableSuccessAlert: true,
    navigate: navigate,
  });
  const {
    // isPending: isPendingPreventaCorporativa,
    mutateAsync: mutateAsyncPutPreventaCorporativo,
  } = fetchPutPreventaCorporativo({
    enableSuccessAlert: true,
    navigate: navigate,
    returnUrl: ROUTER_PATHS.ventasCorporativas.preventaCorporativoNav,
  });


  // ===========================================================================
  // HANDLERS
  // ===========================================================================

  const onSave = async (aprobado_prefactibilidad?: boolean) => {
    const { prospecto_corporativo_options, ...filteredPreventaCorporativa } = form.getValues();

    const resp = await validateSellByOtherUser({ identificacion: filteredPreventaCorporativa?.identificacion });
    const prospectosInfo = resp?.data;
    if (
      prospectosInfo?.prospectos_corporativos?.length > 0 && prospectosInfo?.prospectos_corporativos?.[0]?.user_create__username != currentUsername 
      || prospectosInfo?.prospectos_pymes?.length > 0 && prospectosInfo?.prospectos_pymes?.[0]?.user_create__username != currentUsername
    ) {
      return setAlert(
        true,
        "El cliente que intentas ingresar corresponde a otro Asesor. Por favor, contacte un Supervisor.",
        AlertSeverityEnum.warning,
        4000
      );
    }


    // =========================================================================
    // CAMPOS OBLIGATORIOS TEMPORAL
    // =========================================================================
    if (validacionesPreventasCorporativas(filteredPreventaCorporativa, dataPreventaCorporativa, valorRestriccionCel)) return
    

    // =========================================================================
    // RESETS NECESARIOS
    // =========================================================================
    reset({
      ...filteredPreventaCorporativa,
      codigo: undefined,
      numero_referencia: undefined,
      prospecto_corporativo: dataProspecto?.codigo,
      permitir_edicion: true, //se permite editar hasta que se carguen los documentos
      celular_1: filteredPreventaCorporativa?.celular!,

      observaciones: {
        ...filteredPreventaCorporativa?.observaciones,
        observacion_prefactibilidad: filteredPreventaCorporativa?.observacion_prefactibilidad,
        observacion_preventa: filteredPreventaCorporativa?.observacion_preventa,
      },
      fecha_inicio_plan: filteredPreventaCorporativa?.fecha_inicio_plan
        ? filteredPreventaCorporativa?.fecha_inicio_plan
        : undefined,
      fecha_fin_plan: filteredPreventaCorporativa?.fecha_fin_plan
        ? filteredPreventaCorporativa?.fecha_fin_plan
        : undefined,
      fecha_inicio_evento: filteredPreventaCorporativa?.fecha_inicio_evento
        ? filteredPreventaCorporativa?.fecha_inicio_evento
        : undefined,
      fecha_fin_evento: filteredPreventaCorporativa?.fecha_fin_evento
        ? filteredPreventaCorporativa?.fecha_fin_evento
        : undefined,
    });
    //========================
    //const metodoMensualidad = form.getValues().metodo_pago_mensualidad;
    //const metodoInstalacion = form.getValues().metodo_pago_instalacion;
    //if (!metodoMensualidad) return toast.error(<>El campo <strong>"Forma de pago de servicio"</strong> es obligatorio.</>)
    //if (!metodoInstalacion) return toast.error(<>El campo <strong>"Forma de pago de instalación"</strong> es obligatorio.</>)

    // =========================================================================
    // Para crear Preventas a partir de Prospecto
    // =========================================================================
    if (
      withPreviousProspecto &&
      (!!!filteredPreventaCorporativa?.identificacion ||
        !!!filteredPreventaCorporativa?.prospecto_corporativo)
    ) {
      return setAlert(
        true,
        "Los datos de prospecto previo son obligatorios.",
        AlertSeverityEnum.error
      );
    }
    if (
      withPreviousProspecto &&
      !!filteredPreventaCorporativa?.identificacion &&
      !!filteredPreventaCorporativa?.prospecto_corporativo
    ) {
      const {
        codigo,
        id_prospecto_corporativo,
        estado_prospecto,
        numero_referencia,
        ...restDataProspectoCorporativo
      } = filteredPreventaCorporativa?.prospecto_corporativo_data!;

      restDataProspectoCorporativo.condicion_venta =
        filteredPreventaCorporativa?.condicion_venta;
      //se llena la solicitud de canje
      if (
        filteredPreventaCorporativa?.condicion_venta ==
        CondicionVentaCorporativa.CANJE
      ) {
        restDataProspectoCorporativo.solicitud_canje =
          filteredPreventaCorporativa?.solicitud_canje;
        restDataProspectoCorporativo.solicitud_evento = undefined;

        putSolicitudCanje({
          id_solicitud_canje: filteredPreventaCorporativa?.solicitud_canje,
          canje_aplicado: true,
        });
      }
      //Se llena la solicitud de evento
      if (
        filteredPreventaCorporativa?.condicion_venta ==
        CondicionVentaCorporativa.EVENTO_GRATUITO ||
        filteredPreventaCorporativa?.condicion_venta ==
        CondicionVentaCorporativa.EVENTO_PAGADO
      ) {
        restDataProspectoCorporativo.solicitud_evento =
          filteredPreventaCorporativa?.solicitud_evento;
        restDataProspectoCorporativo.solicitud_canje = undefined;

        putSolicitudEvento({
          id_solicitud_evento: filteredPreventaCorporativa?.solicitud_evento,
          evento_aplicado: true,
        });
      }
      restDataProspectoCorporativo.requiere_inspeccion =
        filteredPreventaCorporativa?.requiere_inspeccion;
      restDataProspectoCorporativo.requiere_cotizacion =
        filteredPreventaCorporativa?.requiere_cotizacion;
      const respProspectoCorporativo = await mutatePostProspectoCorporativo(
        restDataProspectoCorporativo
      );

      if (respProspectoCorporativo?.code !== HTTPResStatusCodeEnum.OK) {
        return setAlert(true, "Hubo un problema al crear el registro, intente de nuevo más tarde", AlertSeverityEnum.error)
      }
      const respPlan = await mutateAsyncPostPlanCorporativo({
        plan_personalizado: true,
        nombre:
          filteredPreventaCorporativa?.data_plan_personalizado
            ?.nombre_personalizado || "PLAN PERSONALIZADO",
        tipo_plan:
          filteredPreventaCorporativa?.data_plan_personalizado
            ?.tipo_plan_personalizado || TipoPlanCorporativo.CORPORATIVO,
        permanencia:
          filteredPreventaCorporativa?.data_plan_personalizado
            ?.permanencia_personalizado || undefined,
        costo_instalacion:
          filteredPreventaCorporativa?.data_plan_personalizado
            ?.costo_instalacion_personalizado || 0,
        valor:
          filteredPreventaCorporativa?.data_plan_personalizado
            ?.valor_personalizado || 0,
        capacidad:
          parseFloat(
            filteredPreventaCorporativa?.data_plan_personalizado
              ?.capacidad_personalizado!
          ) || 100,
      });


      if (filteredPreventaCorporativa?.requiere_backup) {
        const planBackup = await mutateAsyncPostPlanCorporativo({
          plan_personalizado: true,
          nombre: `BACKUP ${filteredPreventaCorporativa?.data_plan_personalizado?.nombre_personalizado}` || "PLAN BACKUP",
          tipo_plan:
            filteredPreventaCorporativa?.data_plan_personalizado
              ?.tipo_plan_personalizado || TipoPlanCorporativo.CORPORATIVO,
          permanencia:
            filteredPreventaCorporativa?.data_plan_personalizado
              ?.permanencia_personalizado || undefined,
          costo_instalacion:
            filteredPreventaCorporativa?.data_plan_personalizado
              ?.costo_instalacion_personalizado || 0,
          valor:
            filteredPreventaCorporativa?.data_plan_personalizado
              ?.valor_personalizado || 0,
          capacidad:
            parseFloat(
              filteredPreventaCorporativa?.data_plan_personalizado
                ?.capacidad_personalizado!
            ) || 100,
        });
        filteredPreventaCorporativa.plan_corporativo_backup = planBackup?.data?.codigo;
        if (filteredPreventaCorporativa?.observaciones) {
          filteredPreventaCorporativa.observaciones.plan_backup = planBackup?.data?.id_plan_coorporativo;
        } else {
          filteredPreventaCorporativa.observaciones = { plan_backup: planBackup?.data?.id_plan_coorporativo };
        }
      }





      if (respPlan?.code !== HTTPResStatusCodeEnum.OK) {
        return setAlert(true, "Hubo un problema al crear los datos de enlace, intente de nuevo más tarde", AlertSeverityEnum.error)
      }


      if (
        respProspectoCorporativo
      ) {

        mutateAsyncPostPreventaCorporativo({
          ...filteredPreventaCorporativa,
          estado_preventa: filteredPreventaCorporativa?.preventa_aprobada_factibilidad
            || aprobado_prefactibilidad ?
            EstadoPreventaEnum.EN_PROCESO
            : filteredPreventaCorporativa?.estado_preventa || EstadoPreventaEnum.EN_ESPERA,
          preventa_aprobada_factibilidad: aprobado_prefactibilidad ? true : false,
          plan: respPlan.data.codigo,
          prospecto_corporativo: respProspectoCorporativo?.data?.codigo,
          observaciones: {
            ...filteredPreventaCorporativa.observaciones,
            observacion_vendedor: filteredPreventaCorporativa?.observacion_vendedor,
            observacion_enlace_backup: filteredPreventaCorporativa?.observacion_enlace_backup,
          },
          servicios_adicionales: serviciosAdicionalesDigitales,
        });
      }
      clearSelectedItems(MaterialesKey.serviciosAdicionalesDigitales)
      return;
    }


    if (
      enableEdit &&
      dataPreventaCorporativa
      // &&
      // filteredPreventaCorporativa?.estado_preventa !=
      //   EstadoPreventaEnum.PREAPROBADA
    ) {
      // if (!!!dataPreventaCorporativa.plan) {
      //   reset({
      //     ...filteredPreventaCorporativa,
      //     capacidad: undefined,
      //   });
      // }
      if (dataPreventaCorporativa.plan) {
        mutateAsyncPutPlanCorporativo({
          id: filteredPreventaCorporativa?.plan_data?.id_plan_coorporativo!,
          data: {
            // plan_personalizado: true,
            nombre:
              filteredPreventaCorporativa?.data_plan_personalizado
                ?.nombre_personalizado || "PLAN PERSONALIZADO",
            tipo_plan:
              filteredPreventaCorporativa?.data_plan_personalizado
                ?.tipo_plan_personalizado || TipoPlanCorporativo.CORPORATIVO,
            permanencia:
              filteredPreventaCorporativa?.data_plan_personalizado
                ?.permanencia_personalizado ||
              undefined,
            costo_instalacion:
              filteredPreventaCorporativa?.data_plan_personalizado
                ?.costo_instalacion_personalizado || 0,
            valor:
              filteredPreventaCorporativa?.data_plan_personalizado
                ?.valor_personalizado || 0,
            capacidad:
              parseFloat(
                filteredPreventaCorporativa?.data_plan_personalizado
                  ?.capacidad_personalizado!
              ) || 100,
          },
        });


        if (filteredPreventaCorporativa?.requiere_backup
          && (filteredPreventaCorporativa?.observaciones?.plan_backup || filteredPreventaCorporativa?.plan_corporativo_backup)) {
          await mutateAsyncPutPlanCorporativo({
            id: (filteredPreventaCorporativa?.observaciones?.plan_backup || filteredPreventaCorporativa?.plan_corporativo_backup)!,
            data: {
              // plan_personalizado: true,
              nombre: `BACKUP ${filteredPreventaCorporativa?.data_plan_personalizado?.nombre_personalizado}` || "PLAN BACKUP",
              tipo_plan:
                filteredPreventaCorporativa?.data_plan_personalizado
                  ?.tipo_plan_personalizado || TipoPlanCorporativo.CORPORATIVO,
              permanencia:
                filteredPreventaCorporativa?.data_plan_personalizado
                  ?.permanencia_personalizado ||
                undefined,
              costo_instalacion:
                filteredPreventaCorporativa?.data_plan_personalizado
                  ?.costo_instalacion_personalizado || 0,
              valor:
                filteredPreventaCorporativa?.data_plan_personalizado
                  ?.valor_personalizado || 0,
              capacidad:
                parseFloat(
                  filteredPreventaCorporativa?.data_plan_personalizado
                    ?.capacidad_personalizado!
                ) || 100,
            },
          });
        } else if (filteredPreventaCorporativa?.requiere_backup) {
          const planBackup = await mutateAsyncPostPlanCorporativo({
            plan_personalizado: true,
            nombre: `BACKUP ${filteredPreventaCorporativa?.data_plan_personalizado?.nombre_personalizado}` || "PLAN BACKUP",
            tipo_plan:
              filteredPreventaCorporativa?.data_plan_personalizado
                ?.tipo_plan_personalizado || TipoPlanCorporativo.CORPORATIVO,
            permanencia:
              filteredPreventaCorporativa?.data_plan_personalizado
                ?.permanencia_personalizado || undefined,
            costo_instalacion:
              filteredPreventaCorporativa?.data_plan_personalizado
                ?.costo_instalacion_personalizado || 0,
            valor:
              filteredPreventaCorporativa?.data_plan_personalizado
                ?.valor_personalizado || 0,
            capacidad:
              parseFloat(
                filteredPreventaCorporativa?.data_plan_personalizado
                  ?.capacidad_personalizado!
              ) || 100,
          });
          filteredPreventaCorporativa.plan_corporativo_backup = planBackup?.data?.codigo
          if (filteredPreventaCorporativa?.observaciones) {
            filteredPreventaCorporativa.observaciones.plan_backup = planBackup?.data?.id_plan_coorporativo;
          } else {
            filteredPreventaCorporativa.observaciones = { plan_backup: planBackup?.data?.id_plan_coorporativo };
          }
        }


      } else {
        // =====================================================================
        // TEMPORAL PARA HACER QUE TODAS LAS PREAPROBADAS TENGAN PLAN
        // =====================================================================
        const respPlan = await mutateAsyncPostPlanCorporativo({
          plan_personalizado: true,
          nombre:
            filteredPreventaCorporativa?.data_plan_personalizado
              ?.nombre_personalizado || "PLAN PERSONALIZADO",
          tipo_plan:
            filteredPreventaCorporativa?.data_plan_personalizado
              ?.tipo_plan_personalizado || TipoPlanCorporativo.CORPORATIVO,
          permanencia:
            filteredPreventaCorporativa?.data_plan_personalizado
              ?.permanencia_personalizado ||
            undefined,
          costo_instalacion:
            filteredPreventaCorporativa?.data_plan_personalizado
              ?.costo_instalacion_personalizado || 0,
          valor:
            filteredPreventaCorporativa?.data_plan_personalizado
              ?.valor_personalizado || 0,
          capacidad:
            parseFloat(
              filteredPreventaCorporativa?.data_plan_personalizado
                ?.capacidad_personalizado!
            ) || 100,
        });
        if (filteredPreventaCorporativa?.requiere_backup) {
          const planBackup = await mutateAsyncPostPlanCorporativo({
            plan_personalizado: true,
            nombre: `BACKUP ${filteredPreventaCorporativa?.data_plan_personalizado?.nombre_personalizado}` || "PLAN BACKUP",
            tipo_plan:
              filteredPreventaCorporativa?.data_plan_personalizado
                ?.tipo_plan_personalizado || TipoPlanCorporativo.CORPORATIVO,
            permanencia:
              filteredPreventaCorporativa?.data_plan_personalizado
                ?.permanencia_personalizado || undefined,
            costo_instalacion:
              filteredPreventaCorporativa?.data_plan_personalizado
                ?.costo_instalacion_personalizado || 0,
            valor:
              filteredPreventaCorporativa?.data_plan_personalizado
                ?.valor_personalizado || 0,
            capacidad:
              parseFloat(
                filteredPreventaCorporativa?.data_plan_personalizado
                  ?.capacidad_personalizado!
              ) || 100,
          });
          filteredPreventaCorporativa.plan_corporativo_backup = planBackup?.data?.codigo
          if (filteredPreventaCorporativa?.observaciones) {
            filteredPreventaCorporativa.observaciones.plan_backup = planBackup?.data?.id_plan_coorporativo;
          } else {
            filteredPreventaCorporativa.observaciones = { plan_backup: planBackup?.data?.id_plan_coorporativo };
          }
        }
        // =====================================================================
        // Set enlace personalizado
        // =====================================================================
        filteredPreventaCorporativa.plan = respPlan.data.codigo
      }

      mutatePutProspectoCorporativo({
        id: dataPreventaCorporativa?.prospecto_corporativo_data
          ?.id_prospecto_corporativo!,
        data: {
          celular: filteredPreventaCorporativa?.celular,
          email: filteredPreventaCorporativa?.email,
          persona_contacto: filteredPreventaCorporativa?.persona_contacto,
          direccion: filteredPreventaCorporativa?.direccion,
        },
      });
      reset({
        ...filteredPreventaCorporativa,
        id_preventa_coorporativa: dataPreventaCorporativa.id_preventa_coorporativa,
        ancho_banda: filteredPreventaCorporativa?.capacidad,
      });
      mutateAsyncPutPreventaCorporativo({
        ...filteredPreventaCorporativa,
        estado_preventa: filteredPreventaCorporativa?.preventa_aprobada_factibilidad
          || aprobado_prefactibilidad ?
          EstadoPreventaEnum.EN_PROCESO
          : filteredPreventaCorporativa?.estado_preventa || EstadoPreventaEnum.EN_ESPERA,
        valor_plan:
          filteredPreventaCorporativa?.data_plan_personalizado
            ?.valor_personalizado,
        observaciones: {
          ...filteredPreventaCorporativa.observaciones,
          observacion_prefactibilidad: filteredPreventaCorporativa?.observacion_prefactibilidad,
          observacion_enlace_backup: filteredPreventaCorporativa?.observacion_enlace_backup,
          observacion_preventa:
            filteredPreventaCorporativa?.observacion_preventa || "N/A",
          observacion_vendedor: filteredPreventaCorporativa?.observacion_vendedor,
        },
        servicios_adicionales: serviciosAdicionalesDigitales,
        // Marcar datos como completados cuando la prefactibilidad ya fue aprobada
        datos_preventa_completados: filteredPreventaCorporativa?.preventa_aprobada_factibilidad || aprobado_prefactibilidad ? true : false,
      });
    } else {
      reset({
        ...filteredPreventaCorporativa,
        capacidad: undefined,
      });
      const respPlan = await mutateAsyncPostPlanCorporativo({
        plan_personalizado: true,
        nombre:
          filteredPreventaCorporativa?.data_plan_personalizado
            ?.nombre_personalizado || "PLAN PERSONALIZADO",
        tipo_plan:
          filteredPreventaCorporativa?.data_plan_personalizado
            ?.tipo_plan_personalizado || TipoPlanCorporativo.CORPORATIVO,
        permanencia:
          filteredPreventaCorporativa?.data_plan_personalizado
            ?.permanencia_personalizado ||
          undefined,
        costo_instalacion:
          filteredPreventaCorporativa?.data_plan_personalizado
            ?.costo_instalacion_personalizado || 0,
        valor:
          filteredPreventaCorporativa?.data_plan_personalizado
            ?.valor_personalizado || 0,
        capacidad:
          parseFloat(
            filteredPreventaCorporativa?.data_plan_personalizado
              ?.capacidad_personalizado!
          ) || 100,
      });
      if (filteredPreventaCorporativa?.requiere_backup) {
        const planBackup = await mutateAsyncPostPlanCorporativo({
          plan_personalizado: true,
          nombre: `BACKUP ${filteredPreventaCorporativa?.data_plan_personalizado?.nombre_personalizado}` || "PLAN BACKUP",
          tipo_plan:
            filteredPreventaCorporativa?.data_plan_personalizado
              ?.tipo_plan_personalizado || TipoPlanCorporativo.CORPORATIVO,
          permanencia:
            filteredPreventaCorporativa?.data_plan_personalizado
              ?.permanencia_personalizado || undefined,
          costo_instalacion:
            filteredPreventaCorporativa?.data_plan_personalizado
              ?.costo_instalacion_personalizado || 0,
          valor:
            filteredPreventaCorporativa?.data_plan_personalizado
              ?.valor_personalizado || 0,
          capacidad:
            parseFloat(
              filteredPreventaCorporativa?.data_plan_personalizado
                ?.capacidad_personalizado!
            ) || 100,
        });
        filteredPreventaCorporativa.plan_corporativo_backup = planBackup?.data?.codigo
        if (filteredPreventaCorporativa?.observaciones) {
          filteredPreventaCorporativa.observaciones.plan_backup = planBackup?.data?.id_plan_coorporativo;
        } else {
          filteredPreventaCorporativa.observaciones = { plan_backup: planBackup?.data?.id_plan_coorporativo };
        }
      }
      if (respPlan.code == 200) {
        mutatePutProspectoCorporativo({
          id: filteredPreventaCorporativa?.id_prospecto_corporativo!,
          data: {
            celular: filteredPreventaCorporativa?.celular,
            email: filteredPreventaCorporativa?.email,
            persona_contacto: filteredPreventaCorporativa?.persona_contacto,
            direccion: filteredPreventaCorporativa?.direccion,
          },
        });

        await mutateAsyncPostPreventaCorporativo({
          ...filteredPreventaCorporativa,
          celular_2: filteredPreventaCorporativa?.celular_2,
          valor_plan: filteredPreventaCorporativa?.data_plan_personalizado?.valor_personalizado,
          plan: respPlan.data.codigo,
          estado_preventa: filteredPreventaCorporativa?.preventa_aprobada_factibilidad
            || aprobado_prefactibilidad ?
            EstadoPreventaEnum.EN_PROCESO
            : filteredPreventaCorporativa?.estado_preventa || EstadoPreventaEnum.EN_ESPERA,
          preventa_aprobada_factibilidad: aprobado_prefactibilidad ? true : false,
          observaciones: {
            ...filteredPreventaCorporativa.observaciones,
            observacion_prefactibilidad: filteredPreventaCorporativa?.observacion_prefactibilidad,
            observacion_enlace_backup: filteredPreventaCorporativa?.observacion_enlace_backup,
            observacion_preventa:
              filteredPreventaCorporativa?.observacion_preventa || "N/A",
            observacion_vendedor: filteredPreventaCorporativa?.observacion_vendedor,
          },
          servicios_adicionales: serviciosAdicionalesDigitales,
        });
      } else {
        setAlert(
          true,
          "Ah ocurrido un error, por favor, recargue la página.",
          "error"
        );
      }
      clearSelectedItems(MaterialesKey.serviciosAdicionalesDigitales)
      return;
      // }
    }
  };

  const handleBuscarProspectoCorporativo = async (identificacion: string) => {

    const resp = await validateSellByOtherUser({ identificacion: identificacion });
    const prospectosInfo = resp?.data;
    if (
      prospectosInfo?.prospectos_corporativos?.length > 0 && prospectosInfo?.prospectos_corporativos?.[0]?.user_create__username != currentUsername 
      || prospectosInfo?.prospectos_pymes?.length > 0 && prospectosInfo?.prospectos_pymes?.[0]?.user_create__username != currentUsername
    ) {
      return setAlert(
        true,
        "El cliente que intentas ingresar corresponde a otro Asesor. Por favor, contacte un Supervisor.",
        AlertSeverityEnum.warning,
        4000
      );
    }


    const params: IDataProspectoCorporativoParams = {
      page: 1,
      page_size: 1,
      es_coorporativo: true,
      filterByState: false,
      identificacion: identificacion,
    };
    try {
      setIsGlobalLoading(true);
      const resp = await getProspectoCorporativoEspecial(params);

      const prospectoOptions = resp?.data?.data;
      if (
        prospectoOptions?.length === 0 ||
        prospectoOptions?.[0]?.estado_prospecto == EstadoProspectoEnum.EN_ESPERA
      ) {
        return setAlert(
          true,
          "Aún no se ha creado ninguna Preventa de este Prospecto. Proceda a crear la Preventa desde la lista del módulo de Prospectos.",
          AlertSeverityEnum.info,
          4000
        );
      }

      if (currentUsername !== prospectoOptions?.[0]?.user_create) {
        return setAlert(
          true,
          "La preventa que intentas ingresar corresponde a otro Asesor. Por favor, contacte un Supervisor.",
          AlertSeverityEnum.warning,
          4000
        );
      }

      form.reset({
        ...form.getValues(),
        coordenada_empresa: prospectoOptions?.[0]?.preventas_corpo_antiguas?.[0]?.coordenada_empresa,
        direccion_empresa: prospectoOptions?.[0]?.preventas_corpo_antiguas?.[0]?.direccion_empresa,
        documentos: prospectoOptions?.[0]?.preventas_corpo_antiguas?.[0]?.documentos,
        // =====================================================================
        // Solo puede crear una nueva preventa el usuario que inicialmente ya creó el prospecto
        // =====================================================================
        prospecto_corporativo_options: prospectoOptions,
      });
    } catch (error) {
      handleAxiosError(error);
    } finally {
      setIsGlobalLoading(false);
    }
  };

  return {
    form,
    handleSubmit,
    onSave,
    handleBuscarProspectoCorporativo,
    sectorsByZonePaging,
    isLoadingSectors,

    loadingPostPreventaCorporativo,
    valorRestriccionCel


  };
};




function validacionesPreventasCorporativas(filteredPreventaCorporativa: SaveFormData, dataPreventaCorporativa?: IPreventaCorporativoForm2, valorRestriccionCel?: any) {
  if (
    CHECK_CAMPOS_OBLIGATORIOS({
      direccion_servicio: filteredPreventaCorporativa?.direccion_servicio,
      coordenada_servicio: filteredPreventaCorporativa?.coordenada_servicio,
      capacidad: filteredPreventaCorporativa?.capacidad,
      capacidad_personalizado: filteredPreventaCorporativa?.data_plan_personalizado?.capacidad_personalizado,
      tipo_plan_personalizado: filteredPreventaCorporativa?.data_plan_personalizado?.tipo_plan_personalizado,
      tipo_plan: filteredPreventaCorporativa?.tipo_plan,
      // tecnico_responsable:filteredPreventaCorporativa?.tecnico_responsable,
      // email_tecnico_responsable:filteredPreventaCorporativa?.email_tecnico_responsable,
      // tipo_servicio:filteredPreventaCorporativa?.tipo_servicio,
      // tipo_enlace:filteredPreventaCorporativa?.tipo_enlace,
      // nombre_personalizado:filteredPreventaCorporativa?.data_plan_personalizado?.nombre_personalizado,
      // permanencia_personalizado:filteredPreventaCorporativa?.data_plan_personalizado?.permanencia_personalizado,
    })
  ) {
    return true
  }

  const { isValid, message } = validateCelularRestriccion(filteredPreventaCorporativa?.celular, valorRestriccionCel)
  if (!isValid && valorRestriccionCel) {
    toast(
      <span>{message}</span>,
      {
        "autoClose": 5000,
        type: AlertSeverityEnum.error
      }
    );
    return true
  }
  const { isValid: isValid2, message: message2 } = validateCelularRestriccion(filteredPreventaCorporativa?.celular_2, valorRestriccionCel)
  if (!isValid2 && valorRestriccionCel) {
    toast(
      <span>{message2}</span>,
      {
        "autoClose": 5000,
        type: AlertSeverityEnum.error
      }
    );
    return true
  }

  if (!filteredPreventaCorporativa?.fibra_oscura) {
    if (!!!filteredPreventaCorporativa?.tipo_plan) {
      toast(
        <span>El campo subtipo de contrato es obligatorio.</span>,
        {
          "autoClose": 5000,
          type: AlertSeverityEnum.error
        }
      );
      return true
    }
    if (
      !!!filteredPreventaCorporativa?.data_plan_personalizado
        ?.capacidad_personalizado
    ) {
      toast(
        <span>El campo enlace es obligatorio.</span>,
        {
          "autoClose": 5000,
          type: AlertSeverityEnum.error
        }
      );
      return true
    }
    if (
      !!!filteredPreventaCorporativa?.data_plan_personalizado
        ?.nombre_personalizado
    ) {
      toast(
        <span>El campo nombre de capacidad es obligatorio.</span>,
        {
          "autoClose": 5000,
          type: AlertSeverityEnum.error
        }
      );
      return true
    }
  }
  if (
    //validamos que sea corporativo normal o evento pagado
    (!filteredPreventaCorporativa?.condicion_venta ||
      filteredPreventaCorporativa?.condicion_venta ==
      CondicionVentaCorporativa.EVENTO_PAGADO) &&
    //validamos que haya sido que este en cualquie
    dataPreventaCorporativa &&
    filteredPreventaCorporativa?.estado_preventa ==
    EstadoPreventaEnum.PREAPROBADA &&
    //validamos si los campos de forma de pago estan vacíos
    (!filteredPreventaCorporativa?.metodo_pago_instalacion ||
      !filteredPreventaCorporativa?.metodo_pago_mensualidad)
  ) {
    toast(
      <span>Los datos de forma de pago son obligatorios.</span>,
      {
        "autoClose": 5000,
        type: AlertSeverityEnum.error
      }
    );
    return true
  }


  if ((filteredPreventaCorporativa?.pre_documentos?.length || 0) > 0 && !filteredPreventaCorporativa?.documentos_guardados) {
    toast.error("Los documentos de la preventa no han sido guardados.")
    return true
  }

  // =========================================================================
  // Validación temporal de los valores números de usuario para plan tvmax
  // =========================================================================
  if (
    !!filteredPreventaCorporativa?.plan_tvmax &&
    ((filteredPreventaCorporativa?.plan_tvmax?.min_usuarios || 1) >
      (filteredPreventaCorporativa?.usuarios_plan_tvmax || 0) ||
      (filteredPreventaCorporativa?.plan_tvmax?.max_usuarios || 1) <
      (filteredPreventaCorporativa?.usuarios_plan_tvmax || 0))
  ) {
    toast(
      <span>El campo número de Usuarios TVMAX debe estar en el rango requerido</span>,
      {
        "autoClose": 5000,
        type: AlertSeverityEnum.error
      }
    );
    return true
  }
  //everything ok
  return false
}



type PROPS_CHECK_CAMPOS_OBLIGATORIOS = {
  direccion_servicio?: string;
  coordenada_servicio?: string;
  capacidad?: string;
  capacidad_personalizado?: string;
  tipo_plan_personalizado?: string;
  tipo_plan?: string;
}
const CHECK_CAMPOS_OBLIGATORIOS = ({
  direccion_servicio,
  coordenada_servicio,
  capacidad,
  capacidad_personalizado,
  tipo_plan_personalizado,
  tipo_plan
  // tecnico_responsable,
  // email_tecnico_responsable,
  // tipo_servicio,
  // tipo_enlace,
  // nombre_personalizado,
  // permanencia_personalizado,
}: PROPS_CHECK_CAMPOS_OBLIGATORIOS) => {
  let camposFaltantes = false
  if (!direccion_servicio) {
    toast(
      <span>Debe ingresar la <b>dirección de servicio</b> obligatoriamente</span>,
      {
        "autoClose": 5000,
        type: AlertSeverityEnum.warning
      }
    )
    // setAlert(true,"Debe ingresar la dirección de servicio obligatoriamente",AlertSeverityEnum.warning, 5000)
    camposFaltantes = true
  }
  if (!coordenada_servicio || coordenada_servicio == "0,0") {
    toast(
      <span>Debe ingresar la <b>coordenada de servicio</b> obligatoriamente</span>,
      {
        "autoClose": 5000,
        type: AlertSeverityEnum.warning
      }
    )
    // setAlert(true,"Debe ingresar la coordenada de servicio obligatoriamente",AlertSeverityEnum.warning, 5000)
    camposFaltantes = true
  }

  if (!capacidad || !capacidad_personalizado || (isNaN(parseFloat(capacidad_personalizado)) || (isNaN(parseFloat(capacidad))))) {
    toast(
      <span>Debe ingresar la <b>capacidad</b> obligatoriamente</span>,
      {
        "autoClose": 5000,
        type: AlertSeverityEnum.warning
      }
    )
    // setAlert(true,"Debe ingresar el tipo de enlace obligatoriamente",AlertSeverityEnum.warning, 5000)
    camposFaltantes = true
  }

  if (!tipo_plan_personalizado || !tipo_plan) {
    toast(
      <span>Debe ingresar el <b>tipo de plan</b> obligatoriamente</span>,
      {
        "autoClose": 5000,
        type: AlertSeverityEnum.warning
      }
    )
    // setAlert(true,"Debe ingresar el tipo de enlace obligatoriamente",AlertSeverityEnum.warning, 5000)
    camposFaltantes = true
  }
  return camposFaltantes


  // if(!tecnico_responsable){
  //   toast(
  //     <span>Debe ingresar el <b>nombre del técnico responsable</b> obligatoriamente</span>,
  //     {
  //       "autoClose":5000,
  //       type:AlertSeverityEnum.warning
  //     }
  //   )
  //   // setAlert(true,"Debe ingresar el nombre del técnico responsable obligatoriamente",AlertSeverityEnum.warning, 5000)
  //   camposFaltantes = true
  // }
  // if(!email_tecnico_responsable){
  //   toast(
  //     <span>Debe ingresar el <b>correo del técnico responsable</b> obligatoriamente</span>,
  //     {
  //       "autoClose":5000,
  //       type:AlertSeverityEnum.warning
  //     }
  //   )
  //   // setAlert(true,"Debe ingresar el correo del técnico responsable obligatoriamente",AlertSeverityEnum.warning, 5000)
  //   camposFaltantes = true
  // }
  // if(!tipo_servicio){
  //   toast(
  //     <span>Debe ingresar el <b>tipo de servicio</b> obligatoriamente</span>,
  //     {
  //       "autoClose":5000,
  //       type:AlertSeverityEnum.warning
  //     }
  //   )
  //   // setAlert(true,"Debe ingresar el tipo de servicio obligatoriamente",AlertSeverityEnum.warning, 5000)
  //   camposFaltantes = true
  // }
  // if(!tipo_enlace){
  //   toast(
  //     <span>Debe ingresar el <b>tipo de enlace</b> obligatoriamente</span>,
  //     {
  //       "autoClose":5000,
  //       type:AlertSeverityEnum.warning
  //     }
  //   )
  //   // setAlert(true,"Debe ingresar el tipo de enlace obligatoriamente",AlertSeverityEnum.warning, 5000)
  //   camposFaltantes = true
  // }


  // if(!nombre_personalizado){
  //   toast(
  //     <span>Debe ingresar el <b>nombre del enlace</b> obligatoriamente</span>,
  //     {
  //       "autoClose":5000,
  //       type:AlertSeverityEnum.warning
  //     }
  //   )
  //   // setAlert(true,"Debe ingresar el nombre del enlace obligatoriamente",AlertSeverityEnum.warning, 5000)
  //   camposFaltantes = true
  // }
  // if(!permanencia_personalizado
  //   && (
  //     permanencia_personalizado == CondicionVentaCorporativa.EVENTO_PAGADO
  //     || permanencia_personalizado == CondicionVentaCorporativa.EVENTO_GRATUITO
  //   )
  // ){
  //   toast(
  //     <span>Debe ingresar el <b>tiempo de permanencia</b> obligatoriamente</span>,
  //     {
  //       "autoClose":5000,
  //       type:AlertSeverityEnum.warning
  //     }
  //   )
  //   // setAlert(true,"Debe ingresar el tiempo de permanencia obligatoriamente",AlertSeverityEnum.warning, 5000)
  //   camposFaltantes = true
  // }

}